<template>
  <div
    v-if="context.request.feature_flags.ff_redesign_rating"
    data-qa="rating_card"
  >
    <RatingRow
      pill
      :solidity="stars"
      :reviews-count="allrates"
      :reviews-href="reviewsHref"
    />
  </div>
  <div
    v-else
    data-qa="rating_card"
    class="rounded-20 border-sm pa-4 primary--text link-decoration-underline cursor-pointer"
    @click="handleClick"
  >
    <div
      class="d-flex align-center gc-2"
      :class="{ 'justify-space-between': isMobile }"
    >
      <StarsRate
        data-qa="rating_stars"
        :solidity="stars"
      />
      <div class="text-body-1 text-no-wrap primary--text">
        <span data-qa="rating_count">{{ allrates }}</span>
        {{ tStatic(rateText) }}
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
/**
 * Рейтинг клиники в шапке branding-страницы.
 *
 * При `ff_redesign_rating` — RatingRow pill: ≤10 отзывов → #otzivi, >10 → lpu_rates.
 * Иначе — bordered-карточка со StarsRate, клик ведёт на #otzivi.
 */
import { computed } from 'vue'
import useIsMobile from 'src/composables/useIsMobile'
import declensionByNum from 'src/utils/declensionByNum'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'
import { useContextStore, useURLStore } from 'src/store'
import type { ContextStore } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/index/types'
import StarsRate from 'src/components/common/StarsRate/StarsRate.vue'
import RatingRow from 'src/components/common/RatingRow/RatingRow.vue'

const props = defineProps<{
  stars: number
  allrates: number
}>()

const isMobile = useIsMobile()
const { context, urlLang }: ContextStore = useContextStore()
const { reverseFullL10N } = useURLStore()

const rateText = computed(() => declensionByNum(props.allrates, ['отзыв', 'отзыва', 'отзывов']))

const reviewsHref = computed(() => {
  const { lpu } = context
  const stayOnPage = props.allrates <= 10 || Boolean(lpu.is_not_index_by_rates_count)

  if (stayOnPage) {
    return '#otzivi'
  }

  const ratesPath = reverseFullL10N({
    name: 'lpu_rates',
    args: {
      language: urlLang,
      town_translit: lpu.town.translit,
      lpu_translit: lpu.translit,
    },
  })

  return `${ratesPath}#${isMobile.value ? 'h1_title' : 'tab-content'}`
})

function handleClick() {
  window.location.hash = 'otzivi'
}
</script>
